const BgIcon = ({ name }) => {
  return (
    <div>
      <img src={name} alt={name} width={28} height={28} />
    </div>
  );
};

export default BgIcon;
